(function () {
    'use strict';

    function workflowSharingController($scope, $state, $timeout, sessionData, milestones,
        workflowStateService, milestoneModalService, notifyService, mailRequestDataService) {
        var vm = this;

        vm.workflowData = {};
        vm.sessionData = sessionData;
        updateWorkflowData();

        vm.flippedOwnerPermissions = {
            AdminConfigModifyingOnly: !vm.workflowData.AdminConfigModifyingOnly,
            AdminSharingOnly: !vm.workflowData.AdminSharingOnly,
            AdminUnderwritingNotesOnly: !vm.workflowData.AdminUnderwritingNotesOnly
        }

        vm.canEditOwnerPermissions = vm.workflowData.AccessLevel === 'ProjectAdmin';

        milestoneModalService.getMilestonesAndTemplates(milestones).then(function (milestonesAndTemplates) {
            if (milestonesAndTemplates.length > 0) {
                milestoneModalService.openModal(milestonesAndTemplates);
            }
        });

        function updateSharingConnectionsStatus() {
            vm.hasSharingConnections = vm.workflowData.SharingConnections.some(function (connection) {
                return connection.IsVisible;
            });
        }

        function updateWorkflowData() {
            vm.workflowData = workflowStateService.get();
            updateSharingConnectionsStatus();
            vm.workflowData.SharingConnections.forEach(function(connection) {
                connection.IsSharedAtProjectLevel = connection.PathAndPermissionMappings.some(function(mapping) {
                    return mapping.path === '';
                });
            });

            vm.canShareAtProjectLevel = vm.workflowData.AccessLevel !== 'SharingPartner';
            vm.canRemoveSharingLevel = vm.workflowData.AccessLevel !== 'SharingPartner';
            vm.canTogglePrivatePartnerConnection = sessionData.EntityType === "Site Administrator" ||
                sessionData.EntityType === "Portal Administrator";
        }

        $scope.$on('workflowUpdated', function () {
            updateWorkflowData();
        });

        vm.canEditPermission = function(permission) {
            if (!vm.workflowData) {
                return false;
            }

            if (vm.workflowData.AccessLevel === 'SharingPartner') {
                return false;
            }

            if (permission === 'View' || permission === 'ShowPartners') {
                return false;
            }

            if (vm.workflowData.AccessLevel === 'ProjectAdmin') {
                return true;
            }

            if (vm.workflowData.AccessLevel === 'ProjectOwner') {
                switch (permission) {
                    case "Edit":
                        return !vm.workflowData.AdminConfigModifyingOnly;
                    case "Share":
                        return !vm.workflowData.AdminSharingOnly;
                    case "Notes":
                        return !vm.workflowData.AdminUnderwritingNotesOnly;
                }
            }

            return false;
        }

        vm.removeSharingConnection = function(entityId, path) {
            var entityConnection = vm.workflowData.SharingConnections.find(function(connection) {
                return connection.EntityId === entityId;
            });

            var index = entityConnection.PathsAndPermissions.map(function (pathAndPermission) { return pathAndPermission.Path; }).indexOf(path);
            var cleanPath = entityConnection.PathAndPermissionMappings[index].cleanPath;
            entityConnection.PathsAndPermissions.splice(index, 1);

            if (entityConnection.PathAndPermissionMappings.length === 0) {
                vm.workflowData.SharingConnections.splice(
                    vm.workflowData.SharingConnections.indexOf(entityConnection), 1);
            }

            workflowStateService.update(vm.workflowData);
            notifyService.notify('You unshared ' + cleanPath + ' with ' +
                entityConnection.Entity.Contact.FirstName + ' ' + entityConnection.Entity.Contact.LastName);

            updateSharingConnectionsStatus();
        }

        vm.toggleSharingPermission = function (entityId, path, permission) {
            $timeout(function() {
                var entityConnection = vm.workflowData.SharingConnections.find(function(connection) {
                    return connection.EntityId === entityId;
                });

                if (!entityConnection) {
                    throw new Error('Could not find entity to toggle permission');
                }

                var index = entityConnection.PathsAndPermissions
                    .map(function(pathAndPermission) { return pathAndPermission.Path; }).indexOf(path);
                var cleanPath = entityConnection.PathAndPermissionMappings[index].cleanPath;

                entityConnection.PathsAndPermissions[index].Permissions[permission] =
                    !entityConnection.PathsAndPermissions[index].Permissions[permission];

                var projectLevelChanges = false;
                if (path === "") {
                    projectLevelChanges = entityConnection.PathsAndPermissions.some(function(pathAndPermission) {
                        return pathAndPermission.Path !== "";
                    });

                    entityConnection.PathsAndPermissions.forEach(function(pathAndPermission) {
                        pathAndPermission.Permissions[permission] =
                            entityConnection.PathsAndPermissions[index].Permissions[permission];
                    });
                }

                workflowStateService.update(vm.workflowData);
                notifyService.notify('You changed sharing permissions for ' +
                    cleanPath +
                    ' for ' +
                    entityConnection.Entity.Contact.FirstName + ' ' + entityConnection.Entity.Contact.LastName + 
                    (projectLevelChanges
                        ? '. Please note, that other permissions have been changed since you made a change at the project level.'
                        : ''));
            }, 0);
        }

        vm.shareAtProjectLevel = function(entityId) {
            var entityConnection = vm.workflowData.SharingConnections.find(function (connection) {
                return connection.EntityId === entityId;
            });

            var permissions = {
                View: true,
                Edit: false,
                Share: false,
                Notes: false
            };

            entityConnection.PathsAndPermissions.push({
                Path: "",
                Permissions: angular.copy(permissions)
            });

            entityConnection.PathsAndPermissions.forEach(function (pathAndPermission) {
                pathAndPermission.Permissions = angular.copy(permissions);
            });

            workflowStateService.update(vm.workflowData);
            notifyService.notify('You shared the project with ' +
                entityConnection.Entity.Contact.FirstName + ' ' + entityConnection.Entity.Contact.LastName + 
                '. Please note, that other permissions have been changed since shared at the project level.');

            mailRequestDataService.sendWorkflowSharingUpdate({
                EntityId: vm.workflowData.EntityId,
                SharedWithEntityId: entityId,
                WorkflowId: vm.workflowData.Id
            });
        }

        vm.toggleOwnerPermission = function (permission) {
            $timeout(function() {
                vm.workflowData[permission] = !vm.flippedOwnerPermissions[flippedOwnerPermissions];
                workflowStateService.update(vm.workflowData);
                notifyService.notify('You modified a project owner permission');
            }, 0);
        }

        vm.togglePrivatePartnerConnection = function (entityId, path) {
            var entityConnection = vm.workflowData.SharingConnections.find(function (connection) {
                return connection.EntityId === entityId;
            });

            var connectionPathAndPermissions = entityConnection.PathsAndPermissions.find(function(pathAndPermissions) {
                return path === pathAndPermissions.Path;
            });

            var index = entityConnection.PathsAndPermissions.map(function (pathAndPermission) { return pathAndPermission.Path; }).indexOf(path);
            var cleanPath = entityConnection.PathAndPermissionMappings[index].cleanPath;

            connectionPathAndPermissions.IsPrivate = !connectionPathAndPermissions.IsPrivate;

            var projectLevelChanges = false;
            if (path === "") {
                projectLevelChanges = entityConnection.PathsAndPermissions.some(function (pathAndPermission) {
                    return pathAndPermission.Path !== "";
                });

                entityConnection.PathsAndPermissions.forEach(function (pathAndPermission) {
                    pathAndPermission.IsPrivate = entityConnection.PathsAndPermissions[index].IsPrivate;
                });
            }

            workflowStateService.update(vm.workflowData);
            notifyService.notify('You changed the sharing visibility for ' +
                entityConnection.Entity.Contact.FirstName + ' ' + entityConnection.Entity.Contact.LastName +
                ' to ' + (entityConnection.IsPrivate ? ' hidden' : 'visible') + ' for ' + cleanPath + '.' +
                (projectLevelChanges ? 'Please note, that other sharing visibilities have been changed since you made a change at the project level.' : ''));

            updateSharingConnectionsStatus();
        }
    }

    workflowSharingController.$inject = ['$scope', '$state', '$timeout', 'sessionData', 'milestones',
        'workflowStateService', 'milestoneModalService', 'notifyService', 'mailRequestDataService'];

    angular.module('ecap.workflow').controller('workflowSharingController', workflowSharingController);
})();
